import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { IconX } from "@tabler/icons-react";
import { createFileRoute, useNavigate, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { ThemeSlot } from "../../../themes/slots";
import { ActionIcon } from "../../../components/ui/ActionIcon";

export const Route = createFileRoute("/c/_menuLayout/cart")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 640px)");

  useEffect(() => {
    if (!isMobile) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobile]);

  const closeCart = () => {
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      navigate({ to: "/c", search: (prev) => prev, replace: true });
    }
  };

  if (!isMobile) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] bg-white overscroll-none">
      <ActionIcon
        variant="transparent"
        size="lg"
        radius="xl"
        className="absolute top-3 right-3 z-60 bg-white hover:bg-white border border-solid border-gray-300 shadow-xl transform hover:scale-110 transition-all"
        aria-label="Close cart"
        onClick={closeCart}
      >
        <IconX color="#000000" />
      </ActionIcon>
      <ThemeSlot slot="cart" />
    </div>
  );
}